export default __webpack_public_path__ + "static/media/writingColor.f8ca064a.png";